import React from 'react';

import { createSvgComponent } from '../../utils/createSvgComponent';
import { illustrations } from './illustrations';

export type IllustrationName = keyof typeof illustrations;
const BaseIllustration = createSvgComponent(illustrations);

export interface IllustrationProps {
    name: IllustrationName;
    width?: number | string;
    height?: number | string;
    className?: string;
    title?: string;
}

export const Illustration: React.FC<IllustrationProps> = ({
    name,
    width,
    height,
    className,
    title,
}: IllustrationProps) => {
    return (
        <BaseIllustration
            name={name}
            width={width}
            height={height}
            className={className}
            role={title ? 'img' : undefined}
            aria-hidden={title ? undefined : true}
        >
            {title ? <title>{title}</title> : null}
        </BaseIllustration>
    );
};
